import { Button } from '@fluentui/react-components';
import { AddRegular, DocumentBulletListRegular } from '@fluentui/react-icons';
import { useNavigate } from 'react-router-dom';
import { PageHeader, CellMono, CellDate, TableStatusBadge } from '../common';
import type { DataTableColumn } from '../common';
import { AsyncList } from '../common/AsyncList';
import { useInstallations, type Installation } from './useInstallations';

const columns: DataTableColumn<Installation>[] = [
  { key: 'customer', header: 'Customer', render: (i) => i.customerName },
  { key: 'product', header: 'Product', render: (i) => i.productName },
  { key: 'version', header: 'Version', render: (i) => <CellMono>{i.version}</CellMono> },
  { key: 'site', header: 'Site', render: (i) => i.siteUrl },
  { key: 'state', header: 'State', render: (i) => <TableStatusBadge status={i.state} /> },
  { key: 'updated', header: 'Updated', render: (i) => <CellDate date={i.updatedAt} /> },
];

export function DeploymentsPage() {
  const navigate = useNavigate();
  const installations = useInstallations();

  return (
    <div>
      <PageHeader
        title="Deployments"
        description="Every FirstIQ product installed in a customer tenant, and where it stands."
        actions={
          <Button appearance="primary" icon={<AddRegular />} onClick={() => navigate('/deploy')}>
            New deployment
          </Button>
        }
      />
      <AsyncList
        state={installations}
        columns={columns}
        keyExtractor={(i) => `${i.tenantId}:${i.productId}`}
        loadingLabel="Loading installation records..."
        empty={{
          icon: <DocumentBulletListRegular />,
          title: 'No deployment records yet',
          description:
            'Installation records from FirstIQ Guardian (customer, product, version, site and state) will appear here once the Deployment Manager reads them from Guardian.',
        }}
      />
    </div>
  );
}
